// Vue
import { computed, ComputedRef } from 'vue'

// State
import {getAutocompleteState} from '../state/autocompleteState'

const regionResults: ComputedRef<number> = computed(() => {
    const autocompleteState = getAutocompleteState()
    const regionLengths = autocompleteState.state.regions.map((region) => {
        return region.regions.length
    })

    return regionLengths.filter((item) => item).length
})

export default regionResults
